export const getVeteranType = (type) =>
  type === "NationalGuardOrReserves" ? type : "ActiveDuty";
